import { useContext } from 'react';

import { PermissionContext } from './PermissionContext';
import type { PermissionContextValue } from './permissionTypes';

/**
 * Access the permission context.
 * Must be used within a `PermissionProvider`.
 */
export function usePermissions(): PermissionContextValue {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionProvider.');
  }
  return context;
}
